module.exports = __webpack_public_path__ + "static/media/boy-11.8f5fc78a.svg";